import { Action } from '@ngrx/store';
import { UserProfile } from './user-profile';

export const LOGIN =    '[Auth] Login';
export const LOGOUT =   '[Auth] Logout';

export class LoginAction implements Action {
  readonly type = LOGIN;

  constructor(public payload: UserProfile) { }
}

export class LogoutAction implements Action {
  readonly type = LOGOUT;
}


export type Actions
  = LoginAction
  | LogoutAction;



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/auth/auth.actions.ts